import {Component, Input, ViewChild} from '@angular/core';
import {RightSideMenuComponent} from "../right-side-menu/right-side-menu.component";
import {SvgIconComponent} from "../svg-icon/svg-icon.component";
import {ProgressComponent} from "../progress/progress.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RightSideMenuComponent,
    SvgIconComponent,
    ProgressComponent,
    NgIf
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @Input() public withIcon: boolean = false;
  @Input() public title: string = "";
  @Input() public progress: number = 0;
  @Input() public progressIsVisible: boolean = false;

  @ViewChild(RightSideMenuComponent) menu!: RightSideMenuComponent

  protected openMenu(event: any) {
    this.menu.open(event)
  }
}
